import { project, environment, nodeEnv, hostEnv } from './configEnvironment';
import {
	Environment,
	HostEnv,
	NodeEnv,
	Project,
} from './configEnvironment.types';

type ConfigItem<Props extends string, Value> =
	| {
			[Key in Props]: Value;
	  }
	| ({ default: Value } & {
			[Key in Props]?: Value;
	  });

export const getConfigFor = {
	project: <Value = never,>(
		configItem: ConfigItem<Project, NoInfer<Value>>,
	): Value => {
		if ('default' in configItem) {
			if (Object.hasOwn(configItem, project)) {
				return configItem[project] as Value;
			}
			return configItem.default;
		}
		return configItem[project];
	},
	environment: <Value = never,>(
		configItem: ConfigItem<Environment, NoInfer<Value>>,
	): Value => {
		if ('default' in configItem) {
			if (Object.hasOwn(configItem, environment)) {
				return configItem[environment] as Value;
			}
			return configItem.default;
		}
		return configItem[environment];
	},
	nodeEnv: <Value = never,>(
		configItem: ConfigItem<NodeEnv, NoInfer<Value>>,
	): Value => {
		if ('default' in configItem) {
			if (Object.hasOwn(configItem, nodeEnv)) {
				return configItem[nodeEnv] as Value;
			}
			return configItem.default;
		}
		return configItem[nodeEnv];
	},
	hostEnv: <Value = never,>(
		configItem: ConfigItem<HostEnv, NoInfer<Value>>,
	): Value => {
		if ('default' in configItem) {
			if (Object.hasOwn(configItem, hostEnv)) {
				return configItem[hostEnv] as Value;
			}
			return configItem.default;
		}
		return configItem[hostEnv];
	},
} as const;
